import * as Yup from 'yup';

export const schema = Yup.object().shape({
	password: Yup.string().required('required'),
	confirmPassword: Yup.string().required({
		messageId: 'required',
	}),
});
